/**
 * Concatenación de clases. Ocho líneas propias en vez de `clsx`: el brief pide
 * cero dependencias de UI de terceros y esto es lo único que se usaba de una.
 */
export type ClassValue =
  | string
  | number
  | null
  | undefined
  | false
  | Record<string, boolean | null | undefined>
  | ClassValue[]

export function cx(...values: ClassValue[]): string {
  const partes: string[] = []

  for (const value of values) {
    if (value === null || value === undefined || value === false) continue
    if (typeof value === 'string' || typeof value === 'number') {
      const texto = String(value).trim()
      if (texto !== '') partes.push(texto)
      continue
    }
    if (Array.isArray(value)) {
      const anidado = cx(...value)
      if (anidado !== '') partes.push(anidado)
      continue
    }
    for (const [clase, activo] of Object.entries(value)) {
      if (activo === true) partes.push(clase)
    }
  }

  return partes.join(' ')
}
